import React from "react";
import cn from "classnames";
import { ReactComponent as DotsIcon } from "./icons/dotsIcon.svg";

import styles from "./Works.module.css";

export default function ItemButton({
    isMobile,
    hoveredLi,
    i,
    isOpen,
    onHandler,
    icon,
    className = null,
}) {
    return (
        isMobile && (
            <button
                className={cn(
                    className,
                    styles.dotsWrapper,
                    {
                        [styles.touch]: isMobile,
                    },
                    {
                        [styles.active]: hoveredLi === i,
                    },
                    {
                        [styles.crossActive]: icon,
                    }
                )}
                onClick={() => onHandler(i, isOpen)}
                aria-label="modal-toggler"
            >
                {icon ? icon : <DotsIcon />}
            </button>
        )
    );
}
